import React from 'react';
import { useSelection } from './SelectionContext';

// The project/bot line from the old MainChatArea.
export default function ChatHeader() {
  const { projectTitle, botTitle } = useSelection();

  return (
    <div className="flex items-center gap-2 px-4 py-2 border-b border-gray-200 bg-white">
      <span className="text-xs font-medium text-gray-500 uppercase">Project:</span>
      <span className={`text-sm font-medium ${projectTitle ? 'text-gray-900' : 'text-gray-400'}`}>
        {projectTitle || 'Not selected'}
      </span>
      <span className="text-gray-300">|</span>
      <span className="text-xs font-medium text-gray-500 uppercase">Bot:</span>
      <span className={`text-sm font-medium ${botTitle ? 'text-gray-900' : 'text-gray-400'}`}>
        {botTitle || 'Not selected'}
      </span>
    </div>
  );
}
